export type TournamentRuleType = 'TIMED' | 'ELIMINATION' | 'BOUNTY' | 'SPECIAL';

export interface PayoutRule {
  pool: { primaryPercent: number; rankBonusPercent: number };
  rankTiers: Array<{ maxEntrants: number | null; shares: number[] }>;
  roundingUnit: number;
}

export interface VenuePayoutRule {
  type: TournamentRuleType;
  version: number;
  rule: PayoutRule;
}

export const ruleLabels: Record<TournamentRuleType, string> = {
  TIMED: '限時錦標賽',
  ELIMINATION: '一般錦標賽',
  BOUNTY: 'Bounty',
  SPECIAL: '特別賽事',
};

export const ruleTypes: TournamentRuleType[] = ['TIMED', 'ELIMINATION', 'BOUNTY', 'SPECIAL'];

export function validPayoutRule(rule: PayoutRule, type?: TournamentRuleType): boolean {
  const { primaryPercent, rankBonusPercent } = rule.pool;
  if (
    ![primaryPercent, rankBonusPercent].every((value) => Number.isInteger(value) && value >= 0) ||
    primaryPercent + rankBonusPercent !== 100 ||
    (type === 'TIMED' && rankBonusPercent !== 3) ||
    !Number.isSafeInteger(rule.roundingUnit) ||
    rule.roundingUnit < 1 ||
    rule.rankTiers.length === 0 ||
    rule.rankTiers.at(-1)?.maxEntrants !== null
  )
    return false;
  let previous = 0;
  return rule.rankTiers.every((tier, index) => {
    const maximum = tier.maxEntrants;
    if (maximum !== null) {
      if (
        !Number.isSafeInteger(maximum) ||
        maximum <= previous ||
        index === rule.rankTiers.length - 1
      )
        return false;
      previous = maximum;
    }
    return (
      tier.shares.length > 0 &&
      tier.shares.every((value) => Number.isInteger(value) && value >= 0) &&
      tier.shares.reduce((sum, value) => sum + value, 0) === 100
    );
  });
}
